<footer  class="text-lg-start">
    <!-- Remove the container if you want to extend the Footer to full width. -->
    
        <!-- Footer -->
        <footer class="text-center text-lg-start text-white" style="background-color: #45526e">
          
	  <!-- Grid container -->
          <div class="p-4 pb-0">
            <!-- Section: Links -->
            <section class="">
              <!--Grid row-->
              <div class="row">
    
                <!-- Grid column -->
                <div class="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
                    <h6 class="text-uppercase mb-4 font-weight-bold">Contact Us</h6>
                    <p><i class="fas fa-home mr-3"></i>Multimedia, Archive and Conservation Section
                    <p><i class="fas fa-envelope mr-3"></i>library@usim.edu.my</p>
                    <p><i class="fas fa-phone  fa-flip-horizontal mr-3"></i>+606-798 6232</p>
                </div>
                 
		<!-- Grid column -->
                                  
                <hr class="w-100 clearfix d-md-none" />
      
                <!-- Grid column -->
                <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
		    <h6 class="text-uppercase mb-4 font-weight-bold">Institutional Repository</h6>
		    <p>"Developed by the USIM Library to offer online access to the university's digital collections as stated in the communities and collections" </p> 
                </div>
      
                <!-- Grid column -->
                <hr class="w-100 clearfix d-md-none" />
      
              </div>

            <!--Grid row-->
            </section>

            <!-- Section: Links -->

	    <!-- Section: Copyright -->

            <section class="p-3 pt-0">
        	<div class="row d-flex align-items-center">
	<!-- Grid column -->
         	<div class="col-md-7 col-lg-8 text-center text-md-start">

	<!-- Copyright -->
            
		<div class="p-3"> &#169; 2022 Copyright:<a class="text-white" href="https://www.usim.edu.my/ms/">Universiti Sains Islam Malaysia</a></div>

        <!-- Copyright -->

          	</div>

	<!-- Grid column -->

        <!-- Grid column -->
		<div class="col-md-5 col-lg-4 ml-lg-0 text-center text-md-end">
            <!-- Facebook -->
            	<a href="https://www.facebook.com/USIMLibrary" class="btn btn-outline-light btn-floating m-1" class="text-white" role="button"><i class="fab fa-facebook-f"></i></a>

            <!-- Twitter -->
            	<a href="https://www.twitter.com/USIMLibrary?s=09" class="btn btn-outline-light btn-floating m-1" class="text-white" role="button"><i class="fab fa-twitter"></i></a>

            <!-- Google -->
            	<a href="https://www.youtube.com/USIMLibraryofficial" class="btn btn-outline-light btn-floating m-1" class="text-white" role="button"><i class="fab fa-youtube"></i></a>

            <!-- Instagram -->
            	<a href="https://www.instagram.com/usim.library/" class="btn btn-outline-light btn-floating m-1" class="text-white" role="button"><i class="fab fa-instagram"></i></a>
          	</div>
        <!-- Grid column -->
        	</div>
      	    </section>

            <!-- Section: Copyright -->
          </div>
          <!-- Grid container -->
     

	  </footer>
    
    </footer>